import React, {useState, useEffect} from "react";
import {motion, useAnimationControls} from 'framer-motion'
import '../CSS/Home.scss'


const HomeSpan = ({children, variant, className}) =>{
    const [isSpace, setIsSpace] = useState(false)
    const [isPlaying, setIsPlaying] = useState(false)
    useEffect(()=>{
        if(children === "\u00A0")
            setIsSpace(true)
    }, [])
    const controls = useAnimationControls();

    const rubberBand = () => {
         controls.start({
            transform: [
                "scale3d(1,1,1)", 
                "scale3d(1.4,.55,1)", 
                "scale3d(.75,1.25,1)", 
                "scale3d(1.25,.85,1)", 
                "scale3d(.9,1.05,1)", 
                "scale3d(1,1,1)"
            ],
            transition: {
                times: [0, .4, .6, .7, .8, .9]
            }
        })
        setIsPlaying(true)
    }

    return(
        <motion.span className={className}
        variants={variant}
        >
            {!isSpace &&(
                <motion.span
                    animate={controls}
                    onMouseOver={() =>{
                        if(!isPlaying)
                            rubberBand() 
                    }}
                    onAnimationComplete={() => setIsPlaying(false)}>
                    {children}
                </motion.span>
            )}
            {isSpace && children}
        </motion.span>
    )
}

export default HomeSpan;